import MagicLinkScreen from '@/src/auth/magicLinkScreen';

export default MagicLinkScreen;
